import React, { useEffect, useState } from "react";
import usflag from "../../assets/images/usflag.png";

const NotificationCarouselGlasses = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isDropping, setIsDropping] = useState(false);

  const womenNames = [
    "Emma",
    "Olivia",
    "Ava",
    "Isabella",
    "Sophia",
    "Charlotte",
    "Mia",
    "Amelia",
    "Harper",
    "Evelyn",
    "Abigail",
    "Emily",
    "Mila",
    "Ella",
    "Avery",
    "Sofia",
    "Camila",
    "Aria",
    "Scarlett",
    "Luna",
  ];

  const frameMatches = [
    "Soft Rectangle",
    "Cat-Eye",
    "Browline",
    "Light Oval",
    "Classic Square",
    "Round Metal",
    "Wayfarer",
    "Thin Frame",
  ];

  const generateNotifications = () => {
    const notifications = [];
    for (let i = 0; i < 20; i += 1) {
      const randomName = womenNames[Math.floor(Math.random() * womenNames.length)];
      const randomFrame = frameMatches[Math.floor(Math.random() * frameMatches.length)];

      notifications.push({
        id: i,
        name: randomName,
        frame: randomFrame,
      });
    }
    return notifications;
  };

  const [notifications] = useState(generateNotifications());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible(false);

      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % notifications.length);
        setIsDropping(true);
        setIsVisible(true);

        setTimeout(() => {
          setIsDropping(false);
        }, 500);
      }, 300);
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [notifications.length]);

  const currentNotification = notifications[currentIndex];

  return (
    <div className="py-2 w-full overflow-hidden">
      <div className="flex items-center justify-center">
        <div
          className={`flex items-center transition-all duration-500 ease-in-out ${
            isVisible
              ? isDropping
                ? "opacity-100 transform translate-y-0 animate-bounce"
                : "opacity-100 transform translate-y-0"
              : "opacity-0 transform -translate-y-4"
          }`}
        >
          <div className="text-xs text-[#6B7280] flex items-center font-['Inter',system-ui,-apple-system,sans-serif] whitespace-nowrap">
            <span className="font-semibold text-[#7C3A8D]">{currentNotification.name}</span>
            <span className="mx-1 text-[#6B7280]">Just got her Glasses Match!</span>
            <img
              src={usflag}
              alt="US Flag"
              className="w-4 h-3 mx-1 rounded-sm object-cover shadow-sm"
            />
            <span className="text-[#6B7280] mr-1">Matched with</span>
            <span className="font-bold text-[#7C3A8D] bg-[#FFE6D1] px-1 py-0.5 rounded text-xs">
              {currentNotification.frame}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCarouselGlasses;
